module.exports = __webpack_public_path__ + "static/img/Visit-left.f300850.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Visit-left.png
// module id = Qd5i
// module chunks = 1